import { AxiosResponse } from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import org_api from "../../../api/org_api";
import { Breadcrumb, Table, Text } from "../../../component/common";
import PaginationButtons from "../../../component/PaginationButtons";

const ClientReport = () => {
  const org_details = JSON.parse(localStorage.getItem("user__details") || "{}");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [allClientReport, setAllClientReport] = useState<
    {
      client_name: string;
      total_position: string;
      candidate_profiles: string;
      selected: string;
      rejected: string;
      completed: string;
      yet_to_interview: string;
      cancelled: string;
      no_show: string;
      proxy: string;
    }[]
  >([]);
  const [clientReport, setClientReport] = useState<
    {
      client_name: string;
      total_position: string;
      candidate_profiles: string;
      selected: string;
      rejected: string;
      completed: string;
      yet_to_interview: string;
      cancelled: string;
      no_show: string;
      proxy: string;
    }[]
  >([]);

  const itemsPerPage = 10;
  useEffect(() => {
    if (org_details.id) {
      fetchAllClientReport(org_details.id);
    }
  }, [org_details.id]);

  useEffect(() => {
    applyPagination();
  }, [allClientReport, currentPage]);

  const fetchAllClientReport = async (org_id: string) => {
    try {
      const res: AxiosResponse = await org_api.clientReport(org_id);

      if (res.data.success) {
        const allData = res.data.schedule || [];
        setAllClientReport(allData);
        setTotalRecords(allData.length);
        const totalPages = Math.ceil(allData.length / itemsPerPage);
        setTotalPages(totalPages);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch client report");
      setAllClientReport([]);
      setTotalRecords(0);
      setTotalPages(0);
    }
  };

  const applyPagination = () => {
    if (allClientReport.length === 0) {
      setClientReport([]);
      return;
    }
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedData = allClientReport.slice(startIndex, endIndex);
    setClientReport(paginatedData);
  };

  const handlePageChange = (newPage: number) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const getTableData = () => {
    const columns = [
      { label: "Client Name", accessor: "client_name" },
      { label: "Total Positions", accessor: "total_position" },
      { label: "Candidate Profiles", accessor: "candidate_profiles" },
      { label: "Selected", accessor: "selected" },
      { label: "Rejected", accessor: "rejected" },
      { label: "Completed", accessor: "completed" },
      { label: "Yet to Interview", accessor: "yet_to_interview" },
      { label: "Cancelled", accessor: "cancelled" },
      { label: "No Show", accessor: "no_show" },
      { label: "Proxy", accessor: "proxy" },
    ];
    const data = clientReport && clientReport.length > 0
      ? clientReport.map((report, index) => ({
        client_name: <Text key={index} text={report.client_name} />,
        total_position: <Text text={report.total_position} />,
        candidate_profiles: <Text text={report.candidate_profiles} />,
        selected: <Text text={report.selected} />,
        rejected: <Text text={report.rejected} />,
        completed: <Text text={report.completed} />,
        yet_to_interview: <Text text={report.yet_to_interview} />,
        cancelled: <Text text={report.cancelled} />,
        no_show: <Text text={report.no_show} />,
        proxy: <Text text={report.proxy} />,
      }))
      : [];

    return { columns, data };
  };





  return (
    <div className="h-[calc(100vh-100px)] 2xl:h-[calc(100vh-115px)] space-y-4">
      <div className="flex items-center justify-between">
        <Breadcrumb
          items={[
            { text: "Reports", href: "/report_list" },
            { text: `Client Report (${totalRecords})`, isActive: true }
          ]}
        />
      </div>

      <div>
        <Table
          columns={getTableData().columns}
          data={getTableData().data}
          isStickyHeader
          containerHeight="h-[calc(100vh-205px)]"
        />

        {totalPages > 1 && (
          <div className="mt-3">
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientReport;